import { feedbackOnFeedbackInitialState } from '@modules/feedback/store/feedbackOnFeedbackInitialState';
import { feedbackOnFeedbackReducer } from '@modules/feedback/store/feedbackOnFeedbackReducer';
import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';

export const useFeedbackOnFeedbackStore = create(
  devtools(redux(feedbackOnFeedbackReducer, feedbackOnFeedbackInitialState), {
    name: 'FeedbackOnFeedbackStore',
  }),
);
